<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;" v-if="master">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="6" LeadsPannel>
            <Item v-if="resource" :item="resource" :extend="true"  @reloadData="reload" :statuses="statuses" :payment_methods="payment_methods"/>
					</v-col>
					<v-col cols="12" md="6" LeadsPannel>
            <v-row class="align-center">
              <v-col cols="12" class="py-0">
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">description</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['new_purchaseOrder']}}
                            </div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['start_a_new_purchaseOrder'] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <EditForm v-if="resource" @onSubmit="onSubmit" :resource.sync="resource" :statuses="statuses" :payment_methods="payment_methods" :countries="countries" @resetApprovedPo="resetApprovedPo" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`" v-if="resource && resource.messages">
                <Conversation :po="resource" @reloadData="reload" />
              </v-col>
            </v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import EditForm from './EditForm.vue';
import Item from './Item.vue'
import Conversation from './Conversation.vue'
export default {
	components: {
    Item,
		EditForm,
    Conversation,
	},
	data() {
		return {
			loading: false,
			resource: null,
      statuses:[],
      payment_methods:[],
		};
	},
	methods: {
     async resetApprovedPo(){
			await this.$store.dispatch('postResource', { resource: '/purchase-orders/reset', value: {purchase_order_id:this.resource.id} })
      this.$store.dispatch('setSnackbar', { type:'success', message:this.i18n['success'] })
      await this.init()
    },
    // wholesale_status_id:
    // in_warehouse_date
    // quotation_quantity
    // quotation_price
    // date_shipped_at
    // date_recieved_at
		getUpload(image) {
			this.resource.image = image.value
		},
		async onSubmit() {
			this.loading = true
			await this.$store.dispatch('putResource', { resource: '/purchase-orders/' + this.resource.items[0].id, value: this.resource.items[0] })
      await this.init()
			this.loading = false
		},
    async reload(){
      await this.init()
    },
    async init(){
      const posData = await this.$store.dispatch('getResource', { resource: `/purchase-orders/${this.$route.params.page}` })
      this.resource = posData.data
      this.resource.items[0].sku = posData.data.items[0].sku
      this.resource.items[0].admin_note = posData.data.admin_note
      this.resource.items[0].crm_po_key = posData.data.crm_po_key
      this.resource.items[0].invoice_total = posData.data.invoice_total
      this.resource.items[0].paid_total = posData.data.paid_total
      this.resource.items[0].funding_percentage = posData.data.funding_percentage
      this.statuses = posData.statuses.map(x=>{return {...x, text:this.i18n['po_' + x.label]}})
      this.payment_methods = posData.payment_methods.map(x=>{return {...x, text:this.i18n['po_' + x.label]}})
    }
	},
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
    master() {
      return this.$store.state.user.role == 'master';
    },
    countries() {
      const keys = Object.keys(this.$store.state.countries_[this.language])
      const values = Object.values(this.$store.state.countries_[this.language])
      const countries = values.map((val, i)=>{
        return {
          text: val, value:keys[i]
        }
      })
      return countries || []
    }
  },
  async mounted() {
    await this.init()
  }
}
</script>